import React, { useEffect, useState } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import Navbar from "../components/Navbar/Main";
import Footer from "../components/Footer/Main";
import Home from "../components/Home/Main";
import About from "../components/About/Main";
import Service from "../components/Services/Service/Main";
import ServiceDetails from "../components/Services/ServiceDetails/Main";
import CompareEMI from "../components/Features/CompareEMI/Main";
import HomeLoan from "../components/Features/HomeLoan/Main";
import HomeLoanEligibility from "../components/Features/HomeLoanEligibility/Main";
import LoanEligibility from "../components/Features/LoanEligibility/Main";
import MonthlyLoan from "../components/Features/MonthlyLoan/Main";
import PersonalLoan from "../components/Features/PersonalLoan/Main";
import Contact from "../components/Contact/Main";
import Loan from "../components/Menapplynow/Loan";
import Withcompare from "../components/Mencompare/Withcompare";
import AdminPage from "../components/Admin/AdminPage";
import Aboutusadmin from "../components/Admin/Aboutusadmin";
import Servicesadmin from "../components/Admin/Servicesadmin";
import Contactadmin from "../components/Admin/Contactadmin";
import Servicedetailadmin from "../components/Admin/Servicedetailadmin";
import Banklist from "../components/Mencompare/Banklist";
import Emicalculator from "../components/Emicalculator/Emicalculator";
import Eligibility from "../components/Eligibility/Eligibility";
import Navbaradmin from "../components/NavbarAdmin/Main";
import AddBank from "../components/Admin/Addbank";
import Chatbotadmin from "../components/Admin/Chatbotadmin";

import Userlist from "../components/Admin/Userlist";
import Loanrequestlist from "../components/Admin/Loanrequestlist";
import Spinners from "../components/Spinners/Spinners";
import Demo from "../components/Demo/Demo";
import RupeeSpinner from "../components/Spinners/Spinners";
import { Link } from "react-router-dom";
import Chatbotnew from "../components/Chatboxnew/Chatboxnew";
import Login from "../components/Login/Login";
import Demoadmin from "../components/Chatbot/Demoadmin";
import Userleads from "../components/Userleads/Userleads";
import Register from "../components/Register/Register";
import Forgetpassword from "../components/Forgetpassword/Forgetpassword";
import Test from "../components/Test/Test";
import Privacypolicy from "../components/Privacypolicy/Privacypolicy";
import Bankcomparison from "../components/Bankcomparison/Bankcomparison";
import Addcomparision from "../components/Admin/Addcomparision";
import CreateShop from "../components/AQrShop/CreateShop";
import ShopList from "../components/AQrShop/ShopList";
import DownloadShopQr from "../components/AQrShop/DownloadShopQr";
import LeadsFromShops from "../components/AQrShop/LeadsFromShops";
import ShopLeadsList from "../components/AQrShop/ShopLeadsList";

const Routing = () => {
  const [homepage, sethomepage] = useState(false);
  const location = useLocation();
  const [isPageLoaded, setIsPageLoaded] = useState(true);

  // --- Add this state for admin authentication globally ---
  const [isAdminAuthenticated, setIsAdminAuthenticated] = useState(() => {
    // Optionally, persist authentication in sessionStorage/localStorage
    return false;
  });

  // --- Move AdminProtectedRoute logic here for immediate check ---
  useEffect(() => {
    // If on an admin route, check authentication immediately
    const adminPaths = [
      "/admin",
      "/aboutusadmin",
      "/serviceadmin",
      "/servicedetailadmin",
      "/preeligibilityadmin",
      "/emicalculatoradmin",
      "/contactusadmin",
      "/userlistadmin",
      "/loanapplicationadmin",
      "/addbank",
      "/chatbotadmin",
      "/leads",
      "/adminregister",
      "/addcomparision",
      "/createshop",
    ];
    if (adminPaths.includes(location.pathname)) {
      if (!isAdminAuthenticated) {
        const pwd = window.prompt("Enter admin password:");
        if (pwd === "Mbs@2025") {
          setIsAdminAuthenticated(true);
        } else {
          alert("Incorrect password!");
          setIsAdminAuthenticated(false);
        }
      }
    }
    if (
      location.pathname === "/admin" ||
      location.pathname === "/aboutusadmin" ||
      location.pathname === "/serviceadmin" ||
      location.pathname === "/servicedetailadmin" ||
      location.pathname === "/preeligibilityadmin" ||
      location.pathname === "/emicalculatoradmin" ||
      location.pathname === "/contactusadmin" ||
      location.pathname === "/userlistadmin" ||
      location.pathname === "/loanapplicationadmin" ||
      location.pathname === "/addbank" ||
      location.pathname === "/chatbotadmin" ||
      location.pathname === "/leads" ||
      location.pathname === "/adminregister" ||
      location.pathname === "/addcomparision" ||
      location.pathname === "/createshop"
    ) {
      sethomepage(false);
    } else {
      sethomepage(true);
    }

    setIsPageLoaded(true);
    const timer = setTimeout(() => {
      setIsPageLoaded(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, [location, isAdminAuthenticated]);

  // --- Updated AdminProtectedRoute to use global state ---
  const AdminProtectedRoute = ({ element }) => {
    if (!isAdminAuthenticated) return null;
    return element;
  };

  return (
    <>
      <Chatbotnew />
      {isPageLoaded ? <RupeeSpinner /> : ""}

      {homepage ? <Navbar /> : <Navbaradmin />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/service" element={<Service />} />
        <Route path="/servicedetails" element={<ServiceDetails />} />
        <Route path="/compareEMI" element={<CompareEMI />} />
        <Route path="/homeloan" element={<HomeLoan />} />
        <Route path="/homeloaneligibility" element={<HomeLoanEligibility />} />
        <Route path="/loaneligibility" element={<LoanEligibility />} />
        <Route path="/monthlyloan" element={<MonthlyLoan />} />
        <Route path="/personalloan" element={<PersonalLoan />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/applynow" element={<Loan />} />
        <Route path="/withcompare" element={<Withcompare />} />
        <Route
          path="/admin"
          element={<AdminProtectedRoute element={<AdminPage />} />}
        />
        <Route
          path="/aboutusadmin"
          element={<AdminProtectedRoute element={<Aboutusadmin />} />}
        />
        <Route
          path="/serviceadmin"
          element={<AdminProtectedRoute element={<Servicesadmin />} />}
        />
        <Route
          path="/contactusadmin"
          element={<AdminProtectedRoute element={<Contactadmin />} />}
        />
        <Route
          path="/servicedetailadmin"
          element={<AdminProtectedRoute element={<Servicedetailadmin />} />}
        />
        <Route path="/banklist" element={<Banklist />} />
        {/* <Route path="/chatbotadmin" element={<Chatbotadmin />} /> */}

        <Route path="/emicalculator" element={<Emicalculator />} />
        <Route path="/preeligibility" element={<Eligibility />} />
        <Route path="/addbank" element={<AddBank />} />
        <Route
          path="/userlistadmin"
          element={<AdminProtectedRoute element={<Userlist />} />}
        />
        <Route
          path="/loanapplicationadmin"
          element={<AdminProtectedRoute element={<Loanrequestlist />} />}
        />
        <Route
          path="/chatbotadmin"
          element={<AdminProtectedRoute element={<Chatbotadmin />} />}
        />
        <Route
          path="/leads"
          element={<AdminProtectedRoute element={<Demoadmin />} />}
        />
        <Route
          path="/adminregister"
          element={<AdminProtectedRoute element={<Userleads />} />}
        />
        <Route
          path="/addcomparision"
          element={<AdminProtectedRoute element={<Addcomparision />} />}
        />
        <Route path="/spinner" element={<Spinners />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgetpassword" element={<Forgetpassword />} />

        <Route path="/demo" element={<Demo />} />
        <Route path="/leads" element={<Demoadmin />} />
        <Route path="/adminregister" element={<Userleads />} />

        <Route path="/emicalculatoradmin" element={<Emicalculator />} />
        <Route path="/preeligibilityadmin" element={<Eligibility />} />
        <Route path="/spinner" element={<Spinners />} />
        <Route path="/test" element={<Test />} />
        <Route path="/privacypolicy" element={<Privacypolicy />} />
        <Route path="/test1" element={<Bankcomparison />} />
        <Route path="/addcomparision" element={<Addcomparision />} />

        {/* for shop qr */}

        <Route
          path="/createshop"
          element={<AdminProtectedRoute element={<CreateShop />} />}
        />
        <Route path="/shoplist" element={<ShopList />} />
        <Route path="/DownloadShopQr" element={<DownloadShopQr />} />
        <Route path="/leadsfromshops" element={<LeadsFromShops />} />
        <Route path="/shopleadslist" element={<ShopLeadsList />} />
      </Routes>
      <Footer />
    </>
  );
};

export default Routing;
